import { call, put } from "redux-saga/effects";
import {
  loginSuccess,
  logoutSuccess,
  error,
  checkTokenSuccess,
  refreshTokenSuccess,
} from "../store/user.store";
import Requests from "../core/requests";

export function* loginUserSaga(action) {
  //auth/login
  try {
    const response = yield call(Requests.auth.login, { ...action.payload });
    yield put({
      type: loginSuccess.type,
      token: response.access_token,
      user: response,
      refresh_token: response.refresh_token,
    });
  } catch (e) {
    yield put({ type: error.type, error: e, typeError: "login" });
  }
}

export function* logoutUserSaga() {
  try {
    yield put({ type: logoutSuccess.type });
  } catch (e) {
    yield put({ type: error.type, error: e, typeError: "logout" });
  }
}

export function* checkTokenSaga(action) {
  try {
    const response = yield call(Requests.auth.checkToken, {
      ...action.payload,
    });
    yield put({
      type: checkTokenSuccess.type,
      expires_in: response?.expires_in,
    });
  } catch (e) {
    yield put({ type: error.type, error: e?.message, typeError: "checkToken" });
  }
}

export function* refreshTokenSaga(action) {
  try {
    const response = yield call(Requests.auth.refreshToken, {
      ...action.payload,
    });

    yield put({
      type: refreshTokenSuccess.type,
      token: response.access_token,
      refresh_token: response.refresh_token,
    });
  } catch (e) {
    yield put({
      type: error.type,
      error: e?.message,
      typeError: "refreshToken",
    });
  }
}
